exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dashboard-navigation {\n  padding: 5px 10px 10px 10px;\n  background-color: #3a5f99;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n.dashboard-navigation label {\n  color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/DashboardNavigation.styl
// module id = 1893
// module chunks = 1